import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { endReplay } from "../../src/shell/endReplay";

import { jump } from "../../src/shell/jump";
import { TimageINT } from "../../src/store/slices/gameObjectSlice";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { doLoopImages, doTransition, doWaitImageByTime, isFollowingVanessaLead } from "../helpers/helpers";
import { V8VanessaCustomerHotel } from "./V8_VanessaCustomerHotel";
import { V9VanessaMCBusNightAfter } from "./V9";
import { images } from "./images";

const v9 = images.v9;
let lastImage: TimageINT;

function shouldShowCustomerStory() {
    // !Game.seenScenarios.includes(`V8VanessaCustomerHotel`) - this is a safeguard in case the player saw this scene already.
    return !Game.seenScenarios.includes(`V8VanessaCustomerHotel`) && Question.globalAnswers.v1WentToTheBarWith === "vanessa";
}

export const V9VanessaMCBusNight = async (): Promise<any> => {

    if (isFollowingVanessaLead()) {
        doTransition(v9.V9VanessaMCBusNight_22);
        vanessa.talk(`That was fun!`);
        vanessa.talk(`We should do it more often!`);

        if (!mc.properties.v9MCFuckedKim) {
            vanessa.talk(`However...`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_23);
            vanessa.talk(`I wonder if I should stop asking you to fuck girls.`);
            if (Question.globalAnswers.v9VanessaMCChrisBehindBarStayed) {
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_22);
                vanessa.talk(`Maybe from now on I'll just let you watch...`);
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_23);
                vanessa.talk(`It seems like you prefer doing that.`);
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_1);
                mc.talk(`I won't deny that.`);
            } else if (Question.globalAnswers.v9VanessaMCChrisBehindBarStayed === false) {
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_23);
                vanessa.talk(`Too bad you left too soon...`);
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_22);
                vanessa.talk(`You should have continued watching me and Chris.`);
                vanessa.talk(`You might have enjoyed it!`);
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_1);
                mc.talk(`Nah... It seemed like you had everything under control.`);

                ImageClass.setImage(images.v9.V9VanessaMCBusNight_22);
                vanessa.talk(`No, really, we needed someone to take pictures.`);
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_23);
                vanessa.talk(`Chris is not good at multi-tasking.`);
                let besidesOrIt = 'It';
                let flag = true;
                if (Question.globalAnswers.v2AgreeToSeeBJPic) {
                    ImageClass.setImage(images.v9.V9VanessaMCBusNight_1);
                    mc.talk(`He didn't seem to have a problem with that a while back.`);
                    ImageClass.setImage(images.v9.V9VanessaMCBusNight_22);
                    vanessa.talk(`Who knows? Maybe a moment of clarity for him...`);
                    besidesOrIt = 'Besides it';
                    flag = false;
                }
                if (Question.globalAnswers.v4SexTapeAgreeToFilm) {
                    ImageClass.setImage(images.v9.V9VanessaMCBusNight_0);
                    mc.talk(`${besidesOrIt} feels like it's becoming my thing taking photos or videos of you fucking other people.`);
                    ImageClass.setImage(images.v9.V9VanessaMCBusNight_4);
                    vanessa.talk(`And whose fault is that?`);
                    ImageClass.setImage(images.v9.V9VanessaMCBusNight_3);
                    mc.talk(`You?`);
                    ImageClass.setImage(images.v9.V9VanessaMCBusNight_2);
                    vanessa.talk(`Mmm...`);
                    ImageClass.setImage(images.v9.V9VanessaMCBusNight_4);
                    vanessa.talk(`Nah...`);
                    flag = false;
                }
                if (flag) {
                    ImageClass.setImage(images.v9.V9VanessaMCBusNight_1);
                    mc.talk(`So maybe he should practice more.`);
                    ImageClass.setImage(images.v9.V9VanessaMCBusNight_1);
                    vanessa.talk(`Mmm...`);
                    ImageClass.setImage(images.v9.V9VanessaMCBusNight_23);
                    vanessa.talk(`I'll let him know.`);
                }
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_22);
                vanessa.talk(`Anyway!`);
            }

        } else {
            if (Question.globalAnswers.v7ReturningOutfitMcAmberLickHerPussy === false) {
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_22);
                vanessa.talk(`And you finally did something and didn't chicken out!`);

            } else {
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_1);
                mc.talk(`I agree.`);
                mc.talk(`Is there more or is it just us fucking random people?`);
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_22);
                vanessa.talk(`I told you already. This is only the start.`);
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_1);
                mc.think(`Interesting.`);

            }

        }

    } else {
        if (Question.globalAnswers.v9VanessaMCChrisBarMCLeadingOptions === "sitAndTalk") {
            doTransition(v9.V9VanessaMCBusNight_4);
            vanessa.talk(`Well... that was boring!`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_2);
            mc.talk(`You seemed to enjoy telling me about yourself for a change.`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_4);
            vanessa.talk(`Boring!!!`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_3);
            mc.talk(`It's not all about sex you know.`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_4);
            vanessa.talk(`We could have done both you know!`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_3);
            mc.talk(`Are you going to be all grumpy with me now?`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_2);
            vanessa.talk(`No.`);


        } else if (Question.globalAnswers.v9VanessaMCChrisBarMCLeadingOptions === "fuckKimAlone") {
            doTransition(v9.V9VanessaMCBusNight_4);
            vanessa.talk(`Well... That was boring!`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_3);
            mc.talk(`Really? I had a blast.`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_4);
            vanessa.talk(`Sure! You got to fuck a hot girl while I sat on my fat ass waiting for you to finish!`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_3);
            mc.talk(`It is what it is...`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_4);
            vanessa.talk(`That's not following the rules by the way!`);
            vanessa.talk(`If you fuck! I should fuck as well!`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_2);
            mc.talk(`I'll remember it for next time.`);

        } else if (Question.globalAnswers.v9VanessaMCChrisBarMCLeadingOptions === "funWithKimTogether") {
            doTransition(v9.V9VanessaMCBusNight_22);
            vanessa.talk(`That was fun!`);
            vanessa.talk(`I'm honestly surprised! I thought you'd chickened out!`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_1);
            mc.talk(`Seriously? Why would I refuse a threesome?`);
            mc.talk(`This bet is a really fun idea. I'm glad you suggested it!`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_22);
            vanessa.talk(`I told you!`);
            vanessa.talk(`Even though next time I'd like to get a dick in me as well.`);
            if (mc.properties.v9MCFuckedKimWithVanessa) {
                mc.talk(`You got mine.`);
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_2);
                vanessa.talk(`Inside of me.`);
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_3);
                mc.talk(`I see.`);
            }
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_1);
            mc.talk(`You can count on me.`);

        } else if (Question.globalAnswers.v9VanessaMCChrisBarMCLeadingOptions === "sendVanessaToChris") {
            doTransition(v9.V9VanessaMCBusNight_22);
            vanessa.talk(`That was fun!`);
            if (Question.globalAnswers.v8VanessaNightFingeredHer === false) {
                vanessa.talk(`After yesterday I thought you are going to deny me sex forever.`);
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_1);
                mc.talk(`Nah... I was just playing...`);
            }
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_22);
            vanessa.talk(`I thought you are going to deny me having sex with guys.`);
            if (Question.globalAnswers.v9VanessaMCChrisBehindBarStayed) {
                vanessa.talk(`But how are you going to watch me fuck if you do...?`);

            } else {
                ImageClass.setImage(images.v9.V9VanessaMCBusNight_22);
                vanessa.talk(`I'm glad I was wrong!`);
                if (Question.globalAnswers.v9VanessaMCChrisBehindBarStayed === false) {
                    ImageClass.setImage(images.v9.V9VanessaMCBusNight_23);
                    vanessa.talk(`You shouldn't have ran away by the way.`);
                    ImageClass.setImage(images.v9.V9VanessaMCBusNight_22);
                    vanessa.talk(`I love being watched.`);
                    ImageClass.setImage(images.v9.V9VanessaMCBusNight_1);
                    mc.talk(`I'll remember it for next time.`);

                }
            }



        }

    }


    return jump(V9VanessaMCBusNight_2, "V9VanessaMCBusNight_2");
};
export const V9VanessaMCBusNight_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v9.V9VanessaMCBusNight_1);
    if (isFollowingVanessaLead()) {
        if (shouldShowCustomerStory()) {
            mc.talk(`By the way, you never told me what happened with your job.`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_22);
            vanessa.talk(`Oh right!`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_23);
            mc.talk(`Well, go ahead. We have time before our stop.`);

        }
        ImageClass.setImage(images.v9.V9VanessaMCBusNight_8);
        if (shouldShowCustomerStory()) {
            vanessa.talk(`But first...`);
            doWaitImageByTime(v9.V9VanessaMCBusNight_5);
            vanessa.talk(`I don't think I quite remember everything...`);
            doWaitImageByTime(v9.V9VanessaMCBusNight_9);
            vanessa.talk(`I need something to refresh my memory.`);
            if (Question.globalAnswers.v7AteVanessaPussy !== undefined) {
                mc.talk(`Didn't you say last time it helps you think?`);
                vanessa.talk(`Does it really matters?`);
            } else {
                mc.talk(`I think I know what you want.`);
                vanessa.talk(`So what's stopping you?`);
            }

        } else {
            vanessa.talk(`You know...`);
            doWaitImageByTime(v9.V9VanessaMCBusNight_5);
            vanessa.talk(`We have a long ride before our stop.`);
            doWaitImageByTime(v9.V9VanessaMCBusNight_9);
            vanessa.talk(`I know how to pass the time.`);
            if (Question.globalAnswers.v7AteVanessaPussy !== undefined) {
                mc.talk(`This again...`);
            }
        }



    } else {

        vanessa.talk(`So...? Are we done for today?`);
    }

    await mc.setQuestion(new Question({ text: `Mmm...`, options: { think: false }, key: `v9VanessaMCBusOptions` })
        .option({ title: `Eat her pussy`, key: "eatPussy" })
        .option({ title: `Finger her`, key: "fingerHer" })
        .option({ title: `Cuddle With her`, key: "cuddle", show: Question.globalAnswers.v9VanessaMCChrisBarMCLeadingOptions === "sitAndTalk" })
        .option({ title: `Do nothing`, key: "nothing" }));

    // if (Question.globalAnswers.v9VanessaMCBusOptions === "eatPussy") {
    //     mc.talk(`If you want me to do it you should strip down completely.`);
    //     vanessa.talk(`Is that a challenge?`);
    //     mc.talk(`I don't know... Is it?`);
    //     ImageClass.setImage(images.v9.V9VanessaMCBusNight_18);
    //     vanessa.talk(`Do you really think that I have a p--`);
    //     ImageClass.setImage(images.v9.V9VanessaMCBusNight_19);
    //     vanessa.talk(`Mhmppp...`);
    //     ImageClass.setImage(images.v9.V9VanessaMCBusNight_20);
    //     vanessa.talk(`With that?\nOf course not!`);
    //     ImageClass.setImage(images.v9.V9VanessaMCBusNight_21);
    //     vanessa.talk(`Your turn.`);

    // } else {
    //     mc.talk(`Fine.`);
    //     ImageClass.setImage(images.v9.V9VanessaMCBusNight_12);

    // }


    if (Question.globalAnswers.v9VanessaMCBusOptions === "eatPussy") {
        if (!isFollowingVanessaLead()) {
            mc.talk(`No.`);
            vanessa.talk(`Oh really?`);
            if (Question.globalAnswers.v9VanessaBusMcLeadingMasturbateMovedSeat === false && (Question.globalAnswers.v9VanessaMCChrisBarMCLeadingOptions !== "sendVanessaToChris")) {
                vanessa.talk(`So there is still hope for me to get some action today!`);
                if (mc.properties.v9MCFuckedKimWithVanessa) {
                    mc.talk(`After helping me out with that chick? Of course!`);

                }
            } else if (mc.properties.v9MCFuckedKimWithVanessa) {
                mc.talk(`Of course, you deserve a reward!`);

            }
            mc.talk(`Start by raising your shirt.`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_8);
            vanessa.talk(`Finally!`);
            doWaitImageByTime(images.v9.V9VanessaMCBusNight_5);
            vanessa.talk(`Now you are talking.`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_6);
            vanessa.talk(`Now what?`);
            mc.talk(`Show me your pussy.`);
            doWaitImageByTime(images.v9.V9VanessaMCBusNight_9);
            mc.talk(`Time for dinner!`);

        }
        doWaitImageByTime(v9.V9VanessaMCBusNight_12);
        vanessa.talk(`Now I can finally focus on the ride.`);
        if (Question.globalAnswers.v9VanessaMCChrisBehindBarStayed === true) {
            mc.think(`The thought of Chris cumming in her not long ago was still in my mind...`);
            mc.think(`I could clearly taste it.`);
            mc.think(`But that didn't stop me.`);

        } else if (Question.globalAnswers.v9VanessaMCChrisBarMCLeadingOptions === "sendVanessaToChris" || Question.globalAnswers.v9VanessaMCChrisBarWatchedVanessaChris !== undefined) {
            mc.think(`I know that Vanessa and Chris were fooling around not long ago.`);
            mc.think(`And I could taste were he had cum...`);
            mc.think(`But that didn't stop me one bit.`);
        }
        doWaitImageByTime(v9.V9VanessaMCBusNight_13);
        await vanessa.setQuestion(new Question({ text: `You are getting good at this!`, options: { think: false }, key: `v9VanessaMCBusNightOptionsEatPussyStripCompletely` })
            .option({ title: `Strip down completely first`, key: true })
            .option({ title: `Continue`, key: false }));


        if (Question.globalAnswers.v9VanessaMCBusNightOptionsEatPussyStripCompletely) {
            doWaitImageByTime(images.v9.V9VanessaMCBusNight_9);
            mc.talk(`You know what?`);
            mc.talk(`Let's take it a step further.`);
            mc.talk(`Take off your clothes completely.`);
            vanessa.talk(`Naughty ${mc.name}!`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_18);
            vanessa.talk(`I accept your c--`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_19);
            vanessa.talk(`Mhmppp...`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_20);
            vanessa.talk(`--llenge`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_21);
            mc.talk(`I can't say that's not hot.`);

        }
        mc.think(`The fact that we were on a public bus didn't stop me one bit.`);
        // I didn't use autoadd here cuz I have a small bug, when rolling back to an image with autoadd the variable gets reverted after the image is set causing to incorrect image to appear
        if (Question.globalAnswers.v9VanessaMCBusNightOptionsEatPussyStripCompletely) {
            doWaitImageByTime(v9.V9VanessaMCBusNight_14.partials.V9VanessaMCBusNight_26);

        } else {
            doWaitImageByTime(v9.V9VanessaMCBusNight_14);

        }
        mc.think(`I kept licking her pussy for a few minutes. Moving my tongue up and down and in circular motions.`);
        if (Question.globalAnswers.v9VanessaMCBusNightOptionsEatPussyStripCompletely) {
            doWaitImageByTime(v9.V9VanessaMCBusNight_13.partials.V9VanessaMCBusNight_25);

        } else {
            doWaitImageByTime(v9.V9VanessaMCBusNight_13);

        }
        mc.think(`As usual, she is so wet.`);
        if (Question.globalAnswers.v9VanessaMCBusNightOptionsEatPussyStripCompletely) {
            doWaitImageByTime(v9.V9VanessaMCBusNight_12.partials.V9VanessaMCBusNight_24);

        } else {
            doWaitImageByTime(v9.V9VanessaMCBusNight_12);

        }
        mc.think(`It's always a surprise to me how this girl can be always be so horny.`);


    }

    else if (Question.globalAnswers.v9VanessaMCBusOptions === "fingerHer") {
        if (Question.globalAnswers.v9VanessaBusMcLeadingMasturbateMovedSeat === false && (Question.globalAnswers.v9VanessaMCChrisBarMCLeadingOptions !== "sendVanessaToChris")) {
            // Vanessa didn't get any action at all
            mc.talk(`You did good today.`);
            vanessa.talk(`By good you mean that I didn't get any action at all?`);
            mc.talk(`Exactly.`);
            mc.talk(`That's why you deserve a reward.`);


        } else {
            mc.talk(`Not yet...`);
            if (mc.properties.v9MCFuckedKimWithVanessa) {
                mc.talk(`I think you deserve a reward.`);
            }
            mc.talk(`Show me that pussy of yours.`);

        }
        doWaitImageByTime(images.v9.V9VanessaMCBusNight_5);
        vanessa.talk(`Say no more!`);
        doWaitImageByTime(images.v9.V9VanessaMCBusNight_9);
        mc.talk(`You didn't waste a second.`);
        vanessa.talk(`Of course not!`);
        doWaitImageByTime(v9.Anim_V9VanessaMCBusNightFingers.poster);
        ImageClass.setAnimation(images.v9.Anim_V9VanessaMCBusNightFingers);
        vanessa.talk(`Ahh...`);

    } else if (Question.globalAnswers.v9VanessaMCBusOptions === "cuddle") {
        mc.talk(`Come here.`);
        doWaitImageByTime(images.v9.V9VanessaMCBusNight_15);
        mc.talk(`Isn't this nice?`);
        doWaitImageByTime(v9.V9VanessaMCBusNight_16);
        vanessa.talk(`Oh... Shut up.`);


    } else {
        if (isFollowingVanessaLead()) {
            mc.talk(`I think it's enough for one day.`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_7);
            vanessa.talk(`Oh...`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_5);
            vanessa.talk(`As expected...`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_4);
            vanessa.talk(`I'll give you a pass this time.`);
            ImageClass.setImage(images.v9.V9VanessaMCBusNight_4);
            vanessa.talk(`But don't get used to it`);

        } else {

            mc.talk(`We are.`);
        }
    }
    if (Question.globalAnswers.v9VanessaMCBusOptions === "eatPussy" || Question.globalAnswers.v9VanessaMCBusOptions === "fingerHer") {

        await endReplay(replayScenesList.V9VanessaMCBusNight_2);
    } else {

        await endReplay();
    }

    if (shouldShowCustomerStory()) {
        return jump(V9VanessaMCBusNight_2_CustomerStory, "V9VanessaMCBusNight_2_CustomerStory");
    }


    return jump(V9VanessaMCBusNight_End, "V9VanessaMCBusNight_End");
};
export const V9VanessaMCBusNight_2_CustomerStory = async (): Promise<any> => {
    vanessa.talk(`I just remembered I never told you what happened with the old grandpa.`);
    vanessa.talk(`Now is the perfect time!`);

    if (Question.globalAnswers.v8FuckedAngela && !Question.globalAnswers.v1EnableNTR) {
        await vanessa.setQuestion(new Question({ text: `Do you want to hear it?`, options: { think: false }, key: `v9VanessaMCBusNightListenToCustomerStory` })
            .option({ title: `Yes`, key: true })
            .option({ title: `No`, key: false }));


        if (Question.globalAnswers.v9VanessaMCBusNightListenToCustomerStory) {
            mc.talk(`Yes.`);
        } else {
            mc.talk(`No.`);
        }
    }

    lastImage = Game.getCurrentImage();
    vanessa.talk(`So...`);
    return jump(V8VanessaCustomerHotel, "V8VanessaCustomerHotel");

};
export const V9VanessaMCBusNight_2_CustomerStory_After = async (): Promise<any> => {
    if (Question.globalAnswers.v9VanessaMCBusOptions === "fingerHer") {
        ImageClass.setAnimation(images.v9.Anim_V9VanessaMCBusNightFingers, { speed: 0.7 });
        if (Question.globalAnswers.v8FuckedAngela) {
            mc.talk(`You showed him!`);
            vanessa.talk(`I did.`);
        } else {
            mc.talk(`Damn...`);
            mc.talk(`At least you got your job back, am I right?`);
        }
        vanessa.talk(`Just keep focusing! You are losing your rhythm!`);
        ImageClass.setAnimation(images.v9.Anim_V9VanessaMCBusNightFingers, { speed: 1.7, wait: true });

    } else {
        doWaitImageByTime(lastImage);
        mc.talk(`Mhmm!`);
        mc.talk(`Slurp!`);
        vanessa.talk(`Shhh... Just focus.`);

    }

    return jump(V9VanessaMCBusNight_End, "V9VanessaMCBusNight_End");
};
export const V9VanessaMCBusNight_End = async (): Promise<any> => {
    return jump(V9VanessaMCBusNightAfter, "V9VanessaMCBusNightAfter");
};

